var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"threejsContainer"},[_c('div',{staticClass:"containerTitle"},[_vm._v("1-15.透视和正交混合渲染（双场景，双相机，单渲染器）"),_c('button',{on:{"click":_vm.intoScene}},[_vm._v("入场")]),_c('button',{on:{"click":_vm.outScene}},[_vm._v("出场")])]),_c('div',{ref:"container",staticClass:"containerBody"})])
}
var staticRenderFns = []

export { render, staticRenderFns }